// Module
var code = "<div class=\"swatch\" v-bind:style=\"{ 'background-color': hexColor }\"></div>";
// Exports
module.exports = code;